import { motion } from 'framer-motion';

const NeonPricing = () => (
  <section className="nv-section nv-pricing" id="pricing">
    <div className="nv-container">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.55 }}
      >
        <p className="nv-eyebrow">Pricing</p>
        <h2 className="nv-title">Custom Song Production</h2>
        <p className="nv-pricing__rate">
          Custom Song — Starting at <strong>$199</strong>
        </p>
        <p className="nv-body">
          Includes up to 3 minutes of professionally crafted music.
        </p>
        <p className="nv-body">
          Additional duration: <strong style={{ color: 'var(--nv-gold)' }}>$50 per finished minute</strong>.
        </p>
        <button
          type="button"
          className="nv-btn nv-btn--primary"
          style={{ marginTop: '1.5rem' }}
          onClick={() =>
            document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
          }
        >
          Get a Quote
        </button>
      </motion.div>
    </div>
  </section>
);

export default NeonPricing;
